import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TrfaFundTypeMasterService {
  AppUrl = '';
  constructor(private readonly _http: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
      this.AppUrl = sessionStorage.getItem('BaseURL') || '';
    }
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }

  GetAllFundType(TokenKey: string, PageNumber: number, PageSize: number, filterText: string, orderBy: string,IsExport:boolean): Observable<any> {
    this.setAPIUrl();
    const data = 'api/TRFAFundTypeMaster/GetAllFundType/' + filterText + '/' + PageNumber + '/' + PageSize + '/' + orderBy+'/'+IsExport;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  FundTypeAddUpdate(TokenKey: string, addNewActionModel: any): Observable<any> {
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/TRFAFundTypeMaster/FundTypeAddUpdate';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, addNewActionModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetFundTypeById(TokenKey: string, fundTypeId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/TRFAFundTypeMaster/GetFundTypeById/' + fundTypeId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  DeleteFundType(TokenKey: string, fundTypeId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/TRFAFundTypeMaster/DeleteFundType/' + fundTypeId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetFundType(TokenKey: string, IsAdmin: boolean = false): Observable<any> {
    this.setAPIUrl();
    const data = 'api/TRFAFundTypeMaster/GetFundType?IsAdmin=' + IsAdmin;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

}
